// extracted by css-extract-rspack-plugin
export default {"chatAgent":"taboola-ultimate-ui-chat-agent-theme_chatAgent__vclG1"};